import {createDeleteMethod, createGetAllMethod, createPostMethod, createPutMethod,} from "../core/factory";
import {entityType} from "./module";

export const getAllQualifiers = () => createGetAllMethod(entityType)
export const deleteQualifier = (payload) => createDeleteMethod(entityType, payload)
export const createQualifier = (payload) => createPostMethod(entityType, payload)
export const updateQualifier = (payload) => createPutMethod(entityType, payload)
